import React from 'react';
import { salesPageData, isPlaceholder } from '../data/salesPageData';
export function UrgencySection() {
  const hasDeadline = !isPlaceholder(salesPageData.promoDeadline);
  const hasCondition = !isPlaceholder(salesPageData.promoCondition);
  return <section className="relative overflow-hidden border-t border-[#EFEDE8]/10 bg-[#111111]" aria-labelledby="urgency-title" data-id="element-414" data-mp="36b8xpy6xxi9r">
      <div className="blueprint-grid absolute inset-0 opacity-40" aria-hidden="true" data-id="element-415" data-mp="3g85683wua4eb" />
      <div className="relative mx-auto max-w-content px-4 py-14 md:px-8 md:py-20" data-id="element-416" data-mp="3g9yflqyu72q0">
        
      </div>
    </section>;
}